
import { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // 1 saniye sonra göster
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white shadow-2xl border-t border-gray-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-4 md:py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex-1 text-center md:text-left">
            <p className="text-sm text-gray-700">
              Web sitemizde size en iyi deneyimi sunabilmek için çerezleri
              kullanıyoruz. Detaylı bilgi için{' '}
              <a
                href="/kvkk"
                className="text-[#14B8A6] hover:underline font-medium"
              >
                KVKK ve Çerez Politikası
              </a>{' '}
              sayfamızı ziyaret edebilirsiniz.
            </p>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={handleReject}
              className="px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-full font-medium hover:bg-gray-50 transition-colors whitespace-nowrap"
            >
              Reddet
            </button>
            <button
              onClick={handleAccept}
              className="px-8 py-3 bg-[#14B8A6] text-white rounded-full font-semibold hover:bg-[#0F9B8E] transition-colors whitespace-nowrap"
            >
              Kabul Et
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
